<div
  class="c-form-element-button"
  [ngClass]="{
    'is-typed': inputSwitchCase === inputPattern.bothDepartureReturnDate || inputSwitchCase === inputPattern.forOneway,
    'is-error': showError && !isOpen && dateForm.touched
  }"
>
  <button
    #inputDate
    type="button"
    class="c-form-element-button__box"
    id="date-selector-modalBtn"
    [attr.aria-controls]="modalId"
    [attr.aria-expanded]="isOpen"
    (throttleClick$)="onClickInput()"
    aswThrottleClick
  >
    <span class="c-form-element-button__wrap">
      <span class="c-form-element-button__label"
        ><span class="c-form-element-button__label-text" [innerHTML]="this.formLabel | staticMsg"></span
      ></span>
      <span class="c-form-element-button__button" [ngSwitch]="this.inputSwitchCase">
        <div *ngSwitchCase="this.inputPattern.bothDepartureReturnDate">
          <span class="c-form-element-button__button-item"
            >{{ dateOrigin | dateFormat : 'default_datetime.selectedFlightDate' }} -
            {{ dateDestination | dateFormat : 'default_datetime.selectedFlightDate' }}
          </span>
        </div>
        <div *ngSwitchCase="this.inputPattern.onlyDepartureDate">
          <span class="c-form-element-button__button-item"
            >{{ dateOrigin | dateFormat : 'default_datetime.selectedFlightDate' }} -</span
          >
        </div>
        <div *ngSwitchCase="this.inputPattern.onlyReturnDate">
          <span class="c-form-element-button__button-item"
            >- {{ dateDestination | dateFormat : 'default_datetime.selectedFlightDate' }}</span
          >
        </div>
        <div *ngSwitchCase="this.inputPattern.forOneway">
          <span class="c-form-element-button__button-item">{{
            dateOrigin | dateFormat : 'default_datetime.selectedFlightDate'
          }}</span>
        </div>
        <div *ngSwitchDefault>
          <span class="c-form-element-button__button-item">{{ placeholder | staticMsg }}</span>
          <input type="hidden" name="button1" value="Depart - Return" id="date-selector-depart-return" />
        </div>
      </span>
    </span>
  </button>
</div>
<ng-container *ngIf="showError && !isOpen && dateForm.touched">
  <asw-validation-error [errorMessage]="errors[0]"></asw-validation-error>
</ng-container>
<!-- [モーダル] -->
<div
  [id]="modalId"
  class="l-modal02 is-open"
  [ngClass]="{ 'display-none-to-inline': isOpen }"
  (keydown)="keyDownModalEvent($event)"
>
  <div class="l-modal02__bg js-modal-close" (click)="blurInput()"></div>
  <div class="l-modal02__inner">
    <div
      #modalContents
      class="l-modal02__contents u-modal-size-pc-1000 js-modal-contents"
      aria-modal="true"
      role="dialog"
      attr.aria-labelledby="modalTitle_{{ id }}"
    >
      <div #modalHead class="l-modal01__header js-modal-head">
        <div class="p-modal-head01">
          <h2 id="modalTitle_{{ id }}" class="p-modal-head01__title" [innerHTML]="modalTitle | staticMsg"></h2>
          <button
            id="date-selector-button1"
            type="button"
            class="p-modal-head01__close js-modal-close"
            (click)="blurInput()"
          >
            <span class="u-visually-hidden" [innerHTML]="staticMessage.altClose | staticMsg"></span>
          </button>
        </div>
      </div>
      <div #modalBody class="l-modal01__body js-modal-body" (scroll)="scroll()">
        <div #modalBodyMonth class="p-modal-select-month">
          <div class="c-select-month">
            <div *ngFor="let year of getDateSection().year" class="c-select-month-area">
              <div class="c-select-month__year">
                {{ 'dateSelect.year' | staticMsg : { '0': year.yearNum } }}
                <div class="c-select-month__list" role="tablist">
                  <div *ngFor="let month of year.month" class="c-select-month__list-item">
                    <button
                      id="date-selector-button2-{{ month.id }}"
                      *ngIf="month.enabled"
                      class="c-select-month__list-item-btn"
                      [ngClass]="{ 'is-current': isCurrentMonth(month) }"
                      role="tab"
                      [attr.aria-controls]="month.id"
                      [attr.aria-selected]="month === selectedMonth"
                      (aria-label)="(month.subDispName)"
                      (click)="clickMonth(month)"
                    >
                      {{ month.selectName | dateFormat : 'default_calendar.header.month' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-modal-calendar">
          <!-- [カレンダー] -->
          <!--
          /=====================================================
          土曜日：c-calendar-month__cell--saturday
          日曜日：c-calendar-month__cell--sunday
          祝日：c-calendar-month__cell--holiday
          開始：c-calendar-month__cell--start + c-calendar-month__cell--interval
          終了：c-calendar-month__cell--end + c-calendar-month__cell--interval
          開始と終了の間：c-calendar-month__cell--interval
          月またぎの初日：c-calendar-month__cell--first-interval + c-calendar-month__cell--interval
          月またぎの最終日：c-calendar-month__cell--last-interval + c-calendar-month__cell--interval
          片道の選択日：c-calendar-month__cell--selected
          選択不可：button要素にdisabled
          選択中のボタン：tabindex="0"
          =====================================================/
        -->
          <div #modalBodyCalendar class="p-modal-calendar__body">
            <!-- [月送り/月戻しボタン]
          /=====================================================
          .c-calendar__btn-arrowに.c-calendar__btn--hide付与で非表示になります
          =====================================================/
          -->
            <button
              id="date-selector-button3"
              class="c-calendar__btn-arrow c-calendar__btn-prev"
              [ngClass]="{ 'c-calendar__btn--hide': !isEnablePrevious() }"
              (click)="clickPrevious()"
            >
              <span class="u-visually-hidden" [innerHTML]="staticMessage.altPrevMonth | staticMsg"></span>
            </button>

            <div class="p-modal-calendar__body-inner">
              <div
                #dateSelectorCalendar
                *ngFor="let month of displayMonthUsed"
                id="{{ month.id }}"
                class="c-calendar"
                role="tabpanel"
              >
                <div class="c-calendar__head">
                  <h3 class="c-calendar__title">
                    {{ month.dispName | dateFormat : 'default_datetime.titleYearMonth' }}
                  </h3>
                </div>
                <div class="c-calendar__body">
                  <div class="c-calendar-month" role="grid">
                    <div class="c-calendar-month__head" role="rowgroup">
                      <div class="c-calendar-month__week-row" role="row">
                        <div
                          *ngFor="let weekName of weekShortName"
                          class="c-calendar-month__week-cell"
                          role="columnheader"
                        >
                          <div
                            class="c-calendar-month__week-cell-item"
                            [attr.aria-label]="weekName | staticMsg"
                            [innerHTML]="weekName | staticMsg"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="c-calendar-month__body" role="rowgroup">
                      <div *ngFor="let week of month.week" class="c-calendar-month__row" role="row">
                        <div
                          *ngFor="let date of week.date"
                          class="c-calendar-month__cell"
                          [ngClass]="{
                            'c-calendar-month__cell--sunday': date.week === 0 && isPosJp,
                            'c-calendar-month__cell--saturday': date.week === 6 && isPosJp,
                            'c-calendar-month__cell--holiday': date.isHoliday && isPosJp,
                            'c-calendar-month__cell--start': date.status === DayStatus.SELECTED_FROM,
                            'c-calendar-month__cell--end': date.status === DayStatus.SELECTED_TO,
                            'c-calendar-month__cell--prevselected':
                              date.isPrevious && date.status !== DayStatus.SELECTED,
                            'c-calendar-month__cell--interval':
                              date.status === DayStatus.SELECTED_SECTION ||
                              date.status === DayStatus.SELECTED_FROM ||
                              date.status === DayStatus.SELECTED_TO,
                            'c-calendar-month__cell--first-interval':
                              date.status === DayStatus.SELECTED_SECTION && date.isFirst,
                            'c-calendar-month__cell--last-interval':
                              date.status === DayStatus.SELECTED_SECTION && date.isLast,
                            'c-calendar-month__cell--selected': date.status === DayStatus.SELECTED
                          }"
                          role="gridcell"
                          aria-selected="false"
                          title="{{ date.title | date : 'yyyy-MM-dd' }}"
                        >
                          <button
                            id="{{ date.id }}"
                            *ngIf="date.status !== DayStatus.HIDE"
                            class="c-calendar-month__cell-button"
                            (click)="clickDate(date)"
                            (keydown)="keyDownDate($event, date)"
                            [disabled]="date.status === DayStatus.DISABLE"
                          >
                            <span>{{ date.num }}</span>
                            <span class="u-visually-hidden">{{ date.title }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              id="date-selector-button5"
              class="c-calendar__btn-arrow c-calendar__btn-next"
              [ngClass]="{ 'c-calendar__btn--hide': !isEnableNext() }"
              [disabled]="!isEnableNext()"
              (click)="clickNext()"
            >
              <span class="u-visually-hidden" [innerHTML]="staticMessage.altNextMonth | staticMsg"></span>
            </button>
          </div>
          <!-- //[カレンダー] -->
        </div>
      </div>
      <div #modalFooter class="l-modal01__footer js-modal-footer">
        <div class="p-modal-foot01">
          <button
            id="date-selector-button6"
            class="c-btn-primary c-btn-primary--s c-btn-primary--min-w100"
            [disabled]="!isApplyEnable"
            (click)="clickApply()"
          >
            <span class="c-btn-primary__text" [innerHTML]="staticMessage.applyButton | staticMsg"></span>
          </button>
        </div>
      </div>
    </div>
    <!-- //[モーダル] -->
  </div>
</div>
